import { atom } from "jotai";

type SignUpActionRedirect = {
  ready: boolean;
};

export const signUpActionRedirectAtom = atom<SignUpActionRedirect>({
  ready: false,
});
